import { apiHelpers } from './api';

/**
 * Available user for expense splits
 */
export interface AvailableUser {
  id: string;
  email: string;
  username: string;
  displayName?: string;
  avatarUrl?: string;
}

export const userService = {
  /**
   * Get all users available for expense splits (excluding current user)
   */
  async getAvailableUsers(): Promise<AvailableUser[]> {
    return apiHelpers.get<AvailableUser[]>('/users/available');
  },
};

export default userService;
